<template>
  <div class="flex">
    <NFormField
      label="Email"
      name="email"
      hint="Optional"
    >
      <NInput
        placeholder="phojrengel@gmail.com"
        leading="i-heroicons-envelope-20-solid"
      />
    </NFormField>
  </div>
</template>
